<template>
    <div>
        <div class="columns is-vcentered">
            <div class="column">
                <p class="my-2 is-size-5">Select the parts of the trip you want to cancel.</p>
            </div>
            <div class="column is-narrow has-text-right-tablet pr-1" v-if="allActiveCount > 1">
                <b-field>
                    <b-checkbox-button type="is-primary" v-model="selectAll" @input="toggleSelectAll">
                        {{ selectAll ? "Unselect All" : "Select All" }}
                    </b-checkbox-button>
                </b-field>
            </div>
        </div>

        <!-- Flight Section -->
        <div v-if="typeList.includes('air')">
            <div v-for="(tst, tstIndex) in trip.tstInfo" :key="tstIndex"
                :class="['type-panel', 'mb-4', { 'isSelected': isTstSelected(tst) }]">
                <div class="section-title is-size-6 has-text-weight-medium">
                    <div class="columns is-mobile is-vcentered">
                        <!-- Checkbox -->
                        <div class="column is-narrow">
                            <b-field>
                                <b-switch type="is-primary" v-model="tst.checked"
                                    @input="toggleTstSegments(tst.checked, tst.segments)">
                                </b-switch>
                            </b-field>
                        </div>
                        <!-- Title -->
                        <div class="column">
                            {{ $helpers.tstTitle(tst) }}
                        </div>
                        <!-- Icon -->
                        <div class="column is-narrow">
                            <div @click="togglePanel(tst)">
                                <b-icon v-model="tst.isClosed" :icon="tst.isClosed ? 'chevron-up' : 'chevron-down'"
                                    size="is-medium" type="is-grey">
                                </b-icon>
                            </div>

                        </div>
                    </div>
                </div>
                <div v-show="!tst.isClosed" class="section-body">
                    <div class="mb-4">
                        <div class="columns is-vcentered">
                            <div class="column">
                                <NDCTag v-if="trip.isNdcBooking" class="mb-5" position="is-right">
                                </NDCTag>
                                <div>
                                    <div v-for="(journey, journeyIndex) in tst.journeys" :key="journeyIndex"
                                        class="journey-segment">
                                        <div v-for="(segment, index) in journey.segments" :key="index">
                                            <ActiveAirSegment :segment="segment" />
                                        </div>
                                    </div>
                                    <div class="columns is-mobile is-multiline ticket-pricing-container">
                                        <!-- Ticket Number -->
                                        <div class="column is-half ticket-number">
                                            Ticket #:
                                            <span v-if="tst.ticketNumber">{{ tst.ticketNumber }}</span>
                                            <span v-else class="has-text-weight-medium">Ticket Pending</span>
                                        </div>
                                        <!-- Pricing -->
                                        <div class="column is-half has-text-right pricing">
                                            Estimated Total: {{ tst.fare.total | formatPriceFromAmount(2, tst.fare.currency) }}
                                            <span class="has-text-grey is-block">
                                                ({{ tst.fare.base | formatPriceFromAmount(2, tst.fare.currency) }} plus tax)
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Hotel Section -->
        <div v-if="typeList.includes('hotel')">
            <div v-for="(segment, index) in activeHotelSegments" :key="index"
                :class="['type-panel', 'mb-4', { 'isSelected': isSegmentSelected(segment) }]">
                <div class="section-title is-size-6 has-text-weight-medium">
                    <div class="columns is-mobile is-vcentered">
                        <!-- Checkbox -->
                        <div class="column is-narrow">
                            <b-field>
                                <b-switch type="is-primary" v-model="segment.checked"
                                    @input="toggleSegmentSelection(segment)">
                                </b-switch>
                            </b-field>
                        </div>
                        <!-- Title -->
                        <div class="column">
                            {{ $helpers.segmentTitle(segment) }}
                        </div>
                        <!-- Icon -->
                        <div class="column is-narrow">
                            <div @click="togglePanel(segment)">
                                <b-icon v-model="segment.isClosed"
                                    :icon="segment.isClosed ? 'chevron-up' : 'chevron-down'" size="is-medium"
                                    type="is-grey">
                                </b-icon>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-show="!segment.isClosed" class="section-body">
                    <div class="mb-4">
                        <div class="columns is-vcentered">
                            <div class="column">
                                <ActiveHotelSegment :segment="segment" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Car Section -->
        <div v-if="typeList.includes('car')">
            <div v-for="(segment, index) in activeCarSegments" :key="index"
                :class="['type-panel', 'mb-4', { 'isSelected': isSegmentSelected(segment) }]">
                <div class="section-title is-size-6 has-text-weight-medium">
                    <div class="columns is-mobile is-vcentered">
                        <!-- Checkbox -->
                        <div class="column is-narrow">
                            <b-field>
                                <b-switch type="is-primary" v-model="segment.checked"
                                    @input="toggleSegmentSelection(segment)">
                                </b-switch>
                            </b-field>

                        </div>
                        <!-- Title -->
                        <div class="column">
                            {{ $helpers.segmentTitle(segment) }}
                        </div>
                        <!-- Icon -->
                        <div class="column is-narrow">
                            <div @click="togglePanel(segment)">
                                <b-icon v-model="segment.isClosed"
                                    :icon="segment.isClosed ? 'chevron-up' : 'chevron-down'" size="is-medium"
                                    type="is-grey">
                                </b-icon>
                            </div>

                        </div>
                    </div>
                </div>
                <div v-show="!segment.isClosed" class="section-body">
                    <div class="mb-4">
                        <div class="columns is-vcentered">
                            <div class="column">
                                <ActiveCarSegment :segment="segment" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!-- Continue Button -->
        <div class="columns">
            <div class="column is-flex is-justify-content-flex-end">
                <b-button type="is-light" @click="goBack" class="mr-2">
                    Go Back
                </b-button>
                <b-button type="is-primary" :disabled="selectedSegments.length === 0" @click="pushToConfirm">
                    Continue
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import router from "@/router";
import ActiveAirSegment from "@/components/Trip/Cancellation/ActiveAirSegment.vue";
import ActiveHotelSegment from "@/components/Trip/Cancellation/ActiveHotelSegment.vue";
import ActiveCarSegment from "@/components/Trip/Cancellation/ActiveCarSegment.vue";
import NDCTag from "@/components/Tags/NDCTag.vue";

export default {
    name: "CancellationSelect",
    components: { ActiveAirSegment, ActiveCarSegment, ActiveHotelSegment, NDCTag },
    props: {
        trip: {
            type: Object,
            required: true,
        },
        activeTripSegments: {
            type: Array,
            required: true,
        },
        preSelectedSegment: {
            required: false
        }
    },
    data() {
        return {
            selectedSegments: [],
            selectAll: false, // Add selectAll property to track state
        };
    },
    methods: {
        goBack() {
            let hash = this.$helpers.encryptText(this.trip.recordLocator);

            router.push({
                name: "trip-detail",
                params: { recordLocatorHash: hash, tripProp: this.trip },
            });
        },
        togglePanel(segment) {
            // Ensure `isOpen` is reactive
            if (segment.isClosed === undefined) {
                this.$set(segment, 'isClosed', true); // Vue.set ensures reactivity
            } else {
                segment.isClosed = !segment.isClosed;
            }
        },
        preSelect(segment) {
            if (Array.isArray(segment)) {
                // Find the matching air segment and select it
                this.trip.tstInfo.forEach((tst) => {
                    if (tst.segments == segment) {
                        tst.checked = true;
                        this.toggleTstSegments(true, segment)
                    }
                });
            } else {
                if (segment.type === "car") {
                    // Find the matching car segment and select it
                    this.activeCarSegments.forEach((carSegment) => {
                        if (carSegment.tattoo === segment.tattoo) {
                            carSegment.checked = true;
                            this.selectedSegments.push(carSegment);
                        }
                    });
                } if (segment.type === "hotel") {
                    // Find the matching hotel segment and select it
                    this.activeHotelSegments.forEach((hotelSegment) => {
                        if (hotelSegment.tattoo === segment.tattoo) {
                            hotelSegment.checked = true;
                            this.selectedSegments.push(hotelSegment);
                        }
                    });
                }
            }

            this.resetPreSelectedSegment();

        },
        resetPreSelectedSegment() {
            this.$emit("resetPreSelectedSegment");
        },
        toggleSelectAll(selectAll) {
            if (selectAll) {
                // Select all flight, car, and hotel segments
                this.trip.tstInfo.forEach((tst) => (tst.checked = true));
                this.activeCarSegments.forEach((segment) => (segment.checked = true));
                this.activeHotelSegments.forEach((segment) => (segment.checked = true));

                // Add all segments to selectedSegments
                this.selectedSegments = [
                    ...this.trip.tstInfo.flatMap((tst) => tst.segments),
                    ...this.activeCarSegments,
                    ...this.activeHotelSegments,
                ];
            } else {
                // Deselect all flight, car, and hotel segments
                this.trip.tstInfo.forEach((tst) => (tst.checked = false));
                this.activeCarSegments.forEach((segment) => (segment.checked = false));
                this.activeHotelSegments.forEach((segment) => (segment.checked = false));

                // Clear selectedSegments
                this.selectedSegments = [];
            }
            
            //Adjust selectAll status
            this.updateSelectAllStatus();
        },
        toggleSelection(isChecked, segments) {
            const segmentArray = Array.isArray(segments) ? segments : [segments];

            if (isChecked) {
                this.selectedSegments.push(...segmentArray);
            } else {
                this.selectedSegments = this.selectedSegments.filter(
                    selectedSegment => !segmentArray.includes(selectedSegment)
                );
            }
            this.updateSelectAllStatus();
        },

        toggleTstSegments(isChecked, segments) {
            this.toggleSelection(isChecked, segments);
        },

        toggleSegmentSelection(segment) {
            this.toggleSelection(segment.checked, segment);
        },
        updateSelectAllStatus() {
            this.selectAll = this.selectedSegments.length === this.allActiveCount;
        },
        pushToConfirm() {
            this.$emit("pushToConfirm", this.selectedSegments);
        },
        resetSelections() {
            // Clear selectedSegments
            this.selectedSegments = [];

            // Reset 'checked' on all segments
            this.trip.tstInfo.forEach(tst => {
                tst.checked = false;
                tst.segments.forEach(segment => segment.checked = false);
            });
            this.activeCarSegments.forEach(segment => segment.checked = false);
            this.activeHotelSegments.forEach(segment => segment.checked = false);
        },
        isSegmentSelected(segment) {
            return this.selectedSegments.includes(segment); // Check if the segment is selected
        },
        isTstSelected(tst) {
            const tstSegs = tst.segments;
            return tstSegs.every(segment => this.selectedSegments.includes(segment));
        }
    },
    computed: {
        typeList() {
            return this.trip ? this.trip.tripSummary.typeList : [];
        },
        activeCarSegments() {
            return this.activeTripSegments.filter((segment) => segment.type === "car");
        },
        activeHotelSegments() {
            return this.activeTripSegments.filter((segment) => segment.type === "hotel");
        },
        allActiveCount() {
            return [
                ...this.trip.tstInfo.flatMap((tst) => tst.segments),
                ...this.activeCarSegments,
                ...this.activeHotelSegments
            ].length;
        }
    },
    mounted() {

        this.resetSelections();

        // Pre-select the segment(s) if passed
        if (this.preSelectedSegment) {
            this.preSelect(this.preSelectedSegment);
        }
    },
};
</script>

<style>
ul {
    list-style-type: disc;
    margin-left: 25px;
}

.type-panel {
    border: 1px rgb(226, 223, 223) solid;
    border-radius: 6px;
}

.type-panel.isSelected {
    background: hsl(347, 90%, 96%);
}

.section-title {
    border-bottom: 1px solid #ddddde;
    padding: 24px 32px;
    position: relative;
    top: 1px;
}

.section-body {
    padding: 24px 32px;
    position: relative;
    top: 1px;
}

.ticket-pricing-container {
    align-items: flex-start;
    /* Align the items to the top when they wrap */
}

.pricing span {
    display: block;
    /* Ensure tax details move to the next line when needed */
}
</style>
